import { mergeSx, tokens, Tooltip, TooltipProps } from '@cast/design-system';

type DataTooltipProps = TooltipProps;

export const DataTooltip = ({
  children,
  title,
  sx,
  ...rest
}: DataTooltipProps) => (
  <Tooltip
    sx={mergeSx(
      {
        backgroundColor: 'unset',
        color: tokens.theme.fg.structural.primary,
        padding: 0,
        marginTop: 0,
        '--ds-tooltip-background': tokens.theme.bg.structural.surface,
        width: 233,
      },
      sx
    )}
    title={title}
    {...rest}
  >
    {children}
  </Tooltip>
);
